var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forgot-complete"},[_c('div',{staticClass:"auth-form__title"},[_vm._v(" "+_vm._s(_vm.$t('registration_thankYou.localization_value.value'))+" ")]),_c('div',{staticClass:"auth-form__subtitle"},[_vm._v(" "+_vm._s(_vm.$t('login_pleaseCheckYour.localization_value.value'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }